import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccessService } from '../../services/access.service';
import { StorageService } from '../../services/storage.service';
import { ApiService } from '../../services/api.service';
import { UserService } from '../../services/user.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-verify-access',
  templateUrl: './verify-access.component.html',
  styleUrls: ['./verify-access.component.scss'],
})
export class VerifyAccessComponent implements OnInit {
  constructor(
    private access: AccessService,
    private store: StorageService,
    private router: Router,
    private http: ApiService,
    private user: UserService
  ) {}

  async ngOnInit(): Promise<void> {
    const cookieToken = this.getCookie('login_access');
    console.log('cookieToken', cookieToken);

    const oldApiKey = this.store.data.apikey;

    if (!cookieToken) {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.access.verifyLogin(cookieToken).subscribe({
      next: async (res) => {
        console.log('Login response:', res);

        if (res.code !== 1) {
          console.warn('Login failed: Invalid response code.');
          this.router.navigate(['/no-access']);
          return;
        }

        const userData = {
          appId: 2,
          apikey: res.data.apikey,
          acc_type: res.data.acc_type,
          userId: res.data.userId,
          termsAccepted: res.data.termsAccepted ? 'true' : 'false',
          termsAgreeDate: res.data.termsAgreeDate,
          termsUpdatedDate: res.data.termsUpdatedDate,
        };

        if (oldApiKey && oldApiKey === res.data.apikey) {
          this.router.navigate(['/dashboard']);
        } else {
          if (oldApiKey) {
            await this.signout();
          }

          this.store.set(userData);
          this.router.navigate(['/dashboard']);
        }
      },
      error: (err) => {
        console.error('Login verification error:', err);
        this.router.navigate(['/no-access']);
      },
    });
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  async signout() {
    try {
      await firstValueFrom(this.http.get('retailers/logout'));
    } catch (err) {
      console.warn('Logout request failed:', err);
    }

    this.store.clearStore();
    this.user.reset();
  }
}
